import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';
import './style.css';

const AddToCart = ({
  product = null,
  listing = false,
  addInCart,
  viewCart,
}) => {
  const [quantity, setQty] = useState(0);
  const [cartList, setCartList] = useState([]);
  const [addedTocart, setAddedTocart] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [addProd, setAddProd] = useState({
    product_id: '',
    quantity: '',
    price: '',
    selling_price: '',
    image: '',
    name: '',
    description: '',
  });

  const onSubmitAddToCart = async (e) => {
    e.preventDefault();
    setAddProd({
      ...addProd,
      product_id: product?.id,
      quantity: quantity,
      price: product?.price,
      selling_price: product?.selling_price,
      image: listing ? product?.images[0]?.image : product?.img[0]?.images,
      name: product?.name,
      description: product?.description,
    });
  };

  useEffect(() => {
    (async () => {
      if (addProd?.product_id && addProd?.name && addProd?.price) {
        setDisabled(true);
        if (cartList && cartList.length === 0) {
          cartList.push(addProd);
          setCartList([...cartList]);
          await addInCart(cartList);
          setAddedTocart(true);
          setDisabled(false);
          setTimeout(() => setAddedTocart(false), 3000);
        } else {
          const isThere = cartList.findIndex(
            (obj) => obj.product_id === addProd.product_id
          );
          if (isThere === -1) {
            if (addProd.quantity > 0) {
              cartList.push(addProd);
            }
            setCartList([...cartList]);
            await addInCart(cartList);
            setAddedTocart(true);
            setDisabled(false);
            setTimeout(() => setAddedTocart(false), 3000);
          } else {
            cartList.splice(isThere, 1);
            if (addProd.quantity > 0) {
              cartList.push(addProd);
            }
            setCartList([...cartList]);
            await addInCart(cartList);
            setAddedTocart(true);
            setDisabled(false);
            setTimeout(() => setAddedTocart(false), 3000);
          }
        }
      }
    })();
  }, [addProd]);

  useEffect(() => {
    if (viewCart) {
      setCartList(viewCart);
    }
  }, [viewCart]);

  useEffect(() => {
    if (cartList) {
      const quan = cartList.filter((obj) => obj.product_id === product?.id);
      if (quan.length) {
        setQty(quan[0].quantity);
      }
    }
  }, [cartList, product]);

  return (
    <Fragment>
      {product?.id && (
        <form onSubmit={(e) => onSubmitAddToCart(e)}>
          <div
            className={
              quantity && quantity > 0 ? 'add-to-cart' : 'add-to-cart mb-0'
            }
          >
            <Button
              type="submit"
              className="add-to-btn btn-transparent"
              disabled={disabled}
            >
              {localization.addToCart}
            </Button>
            <input
              className="prod-qty form-control"
              value={quantity}
              placeholder={localization.qty}
              type="number"
              name="quantity"
              required
              min={0}
              onChange={(e) => {
                if (Regex.number.test(e.target.value)) {
                  setQty(e.target.value);
                }
              }}
            />
          </div>
          {/* <div className={quantity && quantity > 0 ? 'error' : 'error d-block'}>
            {'localization.qtyRequired'}
          </div> */}
          {addedTocart && (
            <p className={listing ? 'addedTocart text-center' : 'addedTocart'}>
              {localization.addedTocart}
            </p>
          )}
        </form>
      )}
    </Fragment>
  );
};

AddToCart.propTypes = {
  product: PropTypes.object,
};

export { AddToCart };
export default AddToCart;
